import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'journey-landing',
  standalone: true,
  imports: [CommonModule, RouterModule, SharedModule],
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent {
  title = environment.title;
  logoSrc = environment.logoSrc;
  heroImageSrc = environment.heroImageSrc;
} 